export const KEYBOARD_PICKER_ERROR_TYPES = {
  MIN_DATE: 'minDate',
  MAX_DATE: 'maxDate',
  INVALID_DATE: 'invalidDate'
};
